import React from "react";

import * as R from "ramda";

import RelatedLinks from "./RelatedLinks";

const getMenuForPage = page => {
  if (page.childPages) {
    return page.childPages;
  }

  if (page.parentPage) {
    const parent = R.find(R.propEq("id", page.parentId), page.parentPage);
    return getMenuForPage(parent);
  }

  return undefined;
};

const childPagesToRelatedLinks = R.map(childPage => ({
  name: childPage.title,
  url: childPage.url,
}));

const PageMenu = ({ page, ...props }) => {
  const menu = getMenuForPage(page);

  return menu ? (
    <RelatedLinks links={childPagesToRelatedLinks(menu)} {...props} />
  ) : null;
};

export default PageMenu;

// Go up 3 levels to get the nearest menu
export const pageMenuFragment = graphql`
  fragment PageMenuFragment on ContentfulPage {
    ...ChildPagesForMenu
    parentPage: page {
      ...ChildPagesForMenu
      parentPage: page {
        ...ChildPagesForMenu
        parentPage: page {
          ...ChildPagesForMenu
          parentPage: page {
            ...ChildPagesForMenu
            parentPage: page {
              ...ChildPagesForMenu
            }
          }
        }
      }
    }
    ...ChildPagesForMenu
  }

  fragment ChildPagesForMenu on ContentfulPage {
    childPages {
      id
      parentId
      ...PageMenuContent
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/PageMenu.js